import { useState } from 'react';

import { Answer, QuestionAttachment } from '@types';
import { showAttachment } from '@features/homeworks/utils';
import Spinner from '@components/spinner/Spinner';
import safeParseHtml from '@utils/safeParseHtml';

interface MCQProps {
  question: any;
  onInputChange: (value: string) => void;
  disableInput?: boolean;
  selectedAnswer?: string;
}

const MCQ = ({
  question,
  onInputChange,
  disableInput = false,
  selectedAnswer = ''
}: MCQProps) => {
  const [selectedQuestion, setSelectedQuestion] = useState<Answer>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const handleSelect = (answer: Answer) => {
    onInputChange(answer?.id || '');
    setSelectedQuestion(answer);
  };

  const isGridView = false;

  return (
    <div className={isGridView ? 'sm:grid sm:grid-cols-2' : ''}>
      {/* OLD QUESTION WRAPPER (with scroll - removed) */}
      {/*
      <div
        className={`w-full ${
          isGridView ? 'sm:overflow-visible sm:max-h-none' : ''
        }`}
      >
      */}

      {/* NEW CLEAN QUESTION WRAPPER */}
      <div className="w-full">
        {question?.questionDetails && (
          <>
            <div className="mb-3 w-fit text-xl font-bold text-primary">
              {question?.questionDetails?.title}
            </div>

            {/* OLD */}
            {/*
            <div className={`mb-12 w-full text-lg font-semibold`}>
            */}

            {/* NEW */}
            <div className="mb-12 w-full text-lg font-semibold">
              {safeParseHtml(question?.questionDetails?.text ?? '')}
            </div>

            <div className="mb-3 w-fit text-xl font-bold text-primary">
              Question
            </div>
          </>
        )}

        {/* OLD */}
        {/*
        <div className={`mb-12 w-3/5 text-lg font-semibold`}>
        */}

        {/* NEW FIXED */}
        <div className="mb-12 w-full text-lg font-semibold">
          {safeParseHtml(question?.question ?? '')}
        </div>

        <div className="mx-1 flex w-full flex-col gap-4">
          {question?.questionAttachments?.map(
            (attachment: QuestionAttachment) => (
              <div key={attachment.id} className="w-full">
                {showAttachment(attachment, true)}
              </div>
            )
          )}
        </div>
      </div>

      {/* ANSWER SIDE */}
      <div
        className={`${
          isGridView
            ? 'sm:-mt-9 sm:ps-10 sm:overflow-visible sm:max-h-none'
            : 'mt-4'
        } ${
          question?.questionDetails?.title ? 'sm:!mt-0' : ''
        } flex cursor-pointer flex-col gap-4`}
      >
        <span className="text-xl font-bold text-primary">
          {question?.title ?? 'Choose the correct answer'}
        </span>

        <div
          className={`w-full ${
            question?.answers[0]?.answerAttachments?.length
              ? `grid w-fit grid-cols-2 gap-3 ${
                  isGridView ? 'desktop:w-2/3' : 'desktop:w-1/2'
                }`
              : 'flex flex-col gap-3'
          }`}
        >
          {question?.answers.map((answer: Answer) => (
            <div
              className={`group w-full rounded-2xl border-2 bg-theme p-3 text-base font-bold shadow-sm transition-all duration-200 sm:p-4 ${
                selectedQuestion?.id === answer.id && selectedAnswer.length > 0
                  ? 'border-primary5 !bg-primaryLite shadow-md'
                  : 'border-grey1 hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-md'
              } ${
                disableInput
                  ? 'cursor-not-allowed opacity-70'
                  : 'cursor-pointer active:scale-[0.98]'
              }`}
              key={answer.id}
              role="presentation"
              onClick={() => !disableInput && handleSelect(answer)}
            >
              <div className="flex h-full items-center justify-start gap-3">
                {/* Selection indicator */}
                <div className="flex h-full shrink-0 items-center">
                  <div
                    className={`flex size-6 items-center justify-center rounded-full border-2 transition-all duration-200 ${
                      selectedAnswer === answer.id
                        ? 'border-primary bg-primary'
                        : 'border-grey bg-theme group-hover:border-primary'
                    }`}
                  >
                    <span
                      className={`size-2.5 rounded-full transition-all ${
                        selectedAnswer === answer.id ? 'bg-white' : ''
                      }`}
                    />
                  </div>
                </div>

                {/* Answer content */}
                {answer?.answerAttachments?.length &&
                answer?.answerAttachments[0]?.type?.toLowerCase() ===
                  'illustration' ? (
                  <>
                    <img
                      src={answer?.answerAttachments[0]?.attachments.url}
                      alt="answer-illustration"
                      className={`size-5/6 min-w-0 rounded-xl object-contain ${
                        !isLoading ? 'block' : 'hidden'
                      }`}
                      onLoad={() => setIsLoading(false)}
                    />
                    {isLoading && <Spinner />}
                  </>
                ) : (
                  <div className="leading-relaxed text-gray-800">
                    {answer.answer ? safeParseHtml(answer.answer) : ' -- '}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MCQ;
